export const types = {
  OPEN_CONFIRM_PROCESS_MATERIAL_MODAL:
    'modules/quotes/modals/OPEN_CONFIRM_PROCESS_MATERIAL_MODAL',
  CLOSE_CONFIRM_PROCESS_MATERIAL_MODAL:
    'modules/quotes/modals/CLOSE_CONFIRM_PROCESS_MATERIAL_MODAL',
  CONFIRM_UPDATE_PROCESS_MATERIAL_REQUEST:
    'modules/quotes/modals/CONFIRM_UPDATE_PROCESS_MATERIAL_REQUEST',
};

export const confirmModal = {
  open: ({ component }) => ({
    type: types.OPEN_CONFIRM_PROCESS_MATERIAL_MODAL,
    payload: { component },
  }),
  close: () => ({
    type: types.CLOSE_CONFIRM_PROCESS_MATERIAL_MODAL,
  }),
  updateProcessMaterial: ({
    componentId,
    processId,
    materialId,
    supplierMaterialId,
    shouldKeepExistingOperations,
  }) => ({
    type: types.CONFIRM_UPDATE_PROCESS_MATERIAL_REQUEST,
    payload: {
      componentId,
      processId,
      materialId,
      supplierMaterialId,
      shouldKeepExistingOperations,
    },
  }),
};
